import { render } from "./IssueCertificate.vue?vue&type=template&id=2604028b&scoped=true"
import script from "./IssueCertificate.vue?vue&type=script&lang=js"
export * from "./IssueCertificate.vue?vue&type=script&lang=js"

import "./IssueCertificate.vue?vue&type=style&index=0&id=2604028b&lang=scss&scoped=true"
import "./IssueCertificate.vue?vue&type=style&index=1&id=2604028b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2604028b"]])

export default __exports__